export interface Bonus {
  label: string
  title: string
  subtitle: string
  body: string
  tagline: string
}

export const bonuses: Bonus[] = [
  {
    label: '🎁 BONUS 1',
    title: 'GASOLINE ENGINE DIAGNOSTIC QUICK REFERENCE HANDBOOK™',
    subtitle: 'Essential Diagnostic References for Faster Troubleshooting',
    body: 'Quickly access symptom-to-system references, essential checks, fuel and ignition guidance, sensor references, fuel-trim patterns and structured diagnostic paths.',
    tagline: 'Find. Check. Diagnose.',
  },
  {
    label: '🎁 BONUS 2',
    title: 'OBD-II CODES & LIVE DATA INTERPRETATION TOOLKIT™',
    subtitle: 'Turn Scan-Tool Data Into Useful Diagnostic Evidence',
    body: 'Understand DTCs, freeze-frame data, fuel trims, sensor readings, misfire information and live-data relationships without treating every code as a failed component.',
    tagline: 'Read. Interpret. Verify.',
  },
  {
    label: '🎁 BONUS 3',
    title: 'NO-START, MISFIRE & DRIVABILITY TROUBLESHOOTING PLAYBOOK™',
    subtitle: 'Structured Diagnostic Paths for Common Engine Problems',
    body: 'Follow practical troubleshooting sequences for crank-no-start, hard starting, misfires, rough idle, hesitation, stalling, power loss and poor fuel economy.',
    tagline: 'Follow. Test. Isolate.',
  },
  {
    label: '🎁 BONUS 4',
    title: 'ELECTRICAL TESTING & SENSOR VERIFICATION FIELD GUIDE™',
    subtitle: 'Verify Circuits, Sensors and Actuators Before Replacing Parts',
    body: 'Use structured references for power, ground, signals, voltage drop, sensor plausibility, injectors, ignition coils and engine-management circuits.',
    tagline: 'Measure. Verify. Confirm.',
  },
  {
    label: '🎁 BONUS 5',
    title: 'DIAGNOSTIC WORKSHEETS & VEHICLE INSPECTION PACK™',
    subtitle: 'Organize Every Step of the Diagnostic Process',
    body: 'Use practical worksheets for vehicle intake, DTCs, freeze-frame data, live data, misfires, fuel systems, sensors, electrical testing and post-repair verification.',
    tagline: 'Record. Organize. Verify.',
  },
]
